// エラーメッセージ
export const ERROR_MESSAGE = {
  FAILED_MOUNT_ROOT: 'Mounted 先の要素が存在しません。',
  INPUT_REQUIRED: '必須項目です。',
  INPUT_HIRAGANA: 'ひらがなで入力してください。',
  INPUT_MIN_VALUE_PHONENUMBER: '10文字以上で入力してください。',
  INPUT_MAX_VALUE_PHONENUMBER: '12文字以下で入力してください。',
  INPUT_EMAIL: 'メールアドレスの形式で入力してください。',
  FAILED_SEND_EMAIL: 'メール送信に失敗しました',
};

// 成功メッセージ
export const SUCCESS_MESSAGE = {
  EMAIL_SEND: 'メールを送信しました',
};

// 画像パス
export const IMAGE = {
  RECRUIT:
    'https://lh3.googleusercontent.com/pw/AP1GczNy0Kfbl5cQcaMPnBtmSJfZXUZPEkg-J92YZhmob-R4H_QAS1Rp3_D0-6tzQAe-pdnuG-u0HQ5EcLeGBFI3gvIiGuxfB3_-PRgbuHzKKAH9MQmTdl-AsHKRo6ZjhA3Q0oge4TKHCERRMv5UVMXD4EuS=w1280-h1280-s-no-gm?authuser=0',
  INSTAGRAM_BANNER:
    'https://lh3.googleusercontent.com/pw/ADCreHfYoMASeN3rRMd5XSgqBL9wjWyMAbudVwS_f2pIpBRUlxhalptsgSyMmherTw310NtAy-yM6DWRqoQ615zNeBdR5au273GGfwOko3bCQiK-R4_NpKFLRWlZSX0GYP6csLykrusiO8wQQH6w7FAnsJgW=w680-h320-s-no?authuser=0',
  LOGO_LARGE_WHITE:
    'https://lh3.googleusercontent.com/pw/ADCreHcdBLqEiVJ5iA_XOUd1jihvWCBAGYizVmyQDmdz5bDeVL3bXMzozuzG8ncLIaDjDPnfTgaiVaOD6uau4She_KUqkQaKLsoccKeUcZ5q-3DuLznK9oQl6Aqe_8uPYNZifGAx5UNfWMgcBiKTIZE9tNpU=w988-h395-s-no?authuser=0',
  SHOP_FRONT_DAY:
    'https://lh3.googleusercontent.com/pw/AP1GczODXc7-L-2WYD5Wcvyc6IYh4VEJQ51888MwZ7F0Y1D1sWrbevfXxhiftwpW7Ur_SWQU36t4Rm2r-Jl-jXK2Qs6y-XVTSk9z8Izll7o5SbXHvcXRvC6QaUmXmLtsR8xN_1x-kn0tB-cP_mlz6BKtmYIJ=w1280-h1280-s-no-gm?authuser=0',
  SHOP_FRONT_NIGHT:
    'https://lh3.googleusercontent.com/pw/AP1GczPWPMoNydUheAx6T0GLL9ZcyEuu8s1kWkrenYkgxXk5rG-Kal53kG9kLhSs4Kum_npX2olQCUO0NaCehb2d8g55wu2KtChGGK2RbEDR71E_GPnayzFndfpdlGEtoVNQadJjko1v1sYOIQwPCSc4NsMt=w1566-h1045-s-no-gm?authuser=0',
  TEL: 'https://lh3.googleusercontent.com/pw/ADCreHdaqHnIcXX7orMIojJIkpZOi3ucPdhsXzlMDWymyPkaloK_jLkiIqJGyCkztTaUS-dBpQVQTCTddAwwc5PSUxgUtJLZfV9KWd2KZt5G5w4vU7Cr7pVDBPX2lOBDK9G0Y-vaCKW4wYmVlektUeBAAbfF=w421-h103-s-no?authuser=0',
  SLIDER_IMAGES: [
    'https://lh3.googleusercontent.com/pw/AP1GczODXc7-L-2WYD5Wcvyc6IYh4VEJQ51888MwZ7F0Y1D1sWrbevfXxhiftwpW7Ur_SWQU36t4Rm2r-Jl-jXK2Qs6y-XVTSk9z8Izll7o5SbXHvcXRvC6QaUmXmLtsR8xN_1x-kn0tB-cP_mlz6BKtmYIJ=w1280-h1280-s-no-gm?authuser=0',
    'https://lh3.googleusercontent.com/pw/AP1GczM_Sp_FqEbWweqtAoGHl7fBNcGq9PXiniPP-ZFXYB6qsBoaOEG2gcPw6F4PKAlnwVUluI7GbS0HYbjpIya1BtGClkjlSDNlD2Q1cxcirFJiTRgOZow2JRekkz2iBMLmBy84B2pDp4zEB66QMVD-se_g=w1280-h1280-s-no-gm?authuser=0',
    'https://lh3.googleusercontent.com/pw/AP1GczMTTFTsGHeOcnx1LP1jfcCP-zAvTb4dcF7OonVvI3z0sQ3Y841JpDG1eOBkAEBsZ-6TAx903w7NnO5Gjhaa-gh_lkP1WvnTNAgrOs1JxuzlbWaA1JMF2kHQsN7qLc4LNFrwhdUv_W3mirNXvd6TSHl_=w1280-h1280-s-no-gm?authuser=0',
    'https://lh3.googleusercontent.com/pw/AP1GczNp77Jx4xxCcd2U2w9Z6G0Yi7iQkBLZVs6G7NoCWbBzigIb8XKVqiDpsq714dhI9ysVgKEws9zgaxcuSBap8vtA9qFD0ITgP-mIvQWQ6WvPDAn0aKG5H-RHY1Fkbf_R1YvMUR-NAHVQEA2gs_H8Ebim=w1280-h1280-s-no-gm?authuser=0',
  ],
  NO_IMAGE:
    'https://lh3.googleusercontent.com/pw/ADCreHcRI-BUmTeiQELCwoxufOLB7hRat8NzmsN-YszIjyDxg_mF1AyaRXqgZCarnGsxzse13X84gd39rmRfYuQeznzBIGGNRIqoK9ydJ_lYVOMEtT7EwNa3k9Adwe5IChvh77HewygYeW2Bv9qc6yMIoMp0=w170-h170-s-no?authuser=0',
  BEER_TAPS:
    'https://lh3.googleusercontent.com/pw/AP1GczNN2Px84VNL2WQqKCrE_2_nsddODavotfiZdZSMY7jOa230x5ZUJGl3F5NtRL-HlrzVqPI0GfhsPAblnCjKQBV0fm5y0BwlGDE-XHj6OW0vsCoqSUq6pzJF36_90GQ-rdfBYkZqI-J_7-S-6wZ-mkgK=w1280-h1280-s-no-gm?authuser=0',
  BEER_CAN_AND_BOTTLE:
    'https://lh3.googleusercontent.com/pw/AP1GczM0UUDJAxN5DdLJw4RrdSUiQlDFSvTQ_WelSIETVIvjDB3mlcmmnsxy1lnXFkTl7xIOGNxZT-7ZgMd5VDDvXhTAvAUkS7zxIlFCexl_2wzANwOaVjqF1g4VRX4hT-ZtbfP4Nd4o_fdkbVQm112d5keo=w1567-h1045-s-no-gm?authuser=0',
  BEER_CANS:
    'https://lh3.googleusercontent.com/pw/AP1GczP-mvByIAsB6HgceUxX252FCRLv7AlJOdh3u2QNXREngxwi9naW77cb5Dx7B080_8YnD7VB_agEZgJAR4lMzdk1lc_DEUZ0oYXKizrx-0bqgFrfENuEStYkyeybpIWChvxXybCqxrFDJ02Sdbp7itei=w1280-h1280-s-no-gm?authuser=0',
};

// リンクパス
export const LINK = {
  INSTAGRAM: 'https://www.instagram.com/craftbeer_freela/?img_index=1',
  GOOGLE_MAP:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3246.4757840154975!2d139.44678957621292!3d35.54195003761174!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018f9ae92a75053%3A0xd50299cb49d2172d!2zQ3JhZnRiZWVyJktpdGNoZW4gZnJlZS5sYSDjgq_jg6njg5Xjg4jjg5Pjg7zjg6vjgqLjg7Pjg4njgq3jg4Pjg4Hjg7Mg44OV44Oq44O844Op!5e0!3m2!1sen!2sjp!4v1695875295559!5m2!1sen!2sjp',
  PRICACY_POLICY:
    'https://drive.google.com/file/d/1ybI1AaG3g2vllcFc9ZVszM3xguzvXnlD/view?usp=sharing',
};

// 重なり順
export const Z_INDEX = {
  HEADER: 3,
  HEADER_MENU: 2,
  MODAL: 4,
};

// カラー
export const COLOR = {
  HEADER_BG: '#fff',
  MENU_BG: 'rgba(34, 34, 34, 0.9)',
  MENU_TEXT: '#fff',
  BUTTON_TEXT: '#000',
  BUTTON_BG: '#fff',
  SUBMIT_BUTTON_TEXT: '#fff',
  SUBMIT_BUTTON_BG: '#000',
  SUBMIT_BUTTON_DISABLED_BG: '#d1d1d1',
  BUTTON_BORDER: '#000',
  BORDER: '#000',
  ERROR_TEXT: '#f00',
  SUCCESS_BG: '#b9ffe5',
  SUCCESS_BORDER: '#3f9877',
  FAILED_BG: '#ffb9b9',
  FAILED_BORDER: '#983f3f',
  FORM_LABEL_BORDER: '#000',
  FORM_INPUT_BORDER: '#000',
  FORM_INPUT_BORDER_ERROR: '#f00',
  FORM_TEXT: '#000',
  PRICE_TEXT: '#f00',
  MODAL_BG: '#fff',
};

// フォント名
export const FONT_FAMILY = {
  MENU: 'Elsie Swash Caps',
  HEADER_LARGE: 'Elsie Swash Caps',
  HEADER_MIDDLE: 'Elsie Swash Caps',
  HEADER_SMALL: 'Elsie Swash Caps',
};

// EmailJS
export const EMAILJS = {
  SERVICE_ID: 'service_a18clgq',
  PUBLIC_KEY: 'zNBOLqTYZuWQR1JbH',
  TEMPLATE_ID: {
    RECRUIT: 'template_ppw4e9m',
    OTHER: 'template_66mnvdq',
  },
};
